import { render } from "./OidcCallbackPage.vue?vue&type=template&id=67081784"
import script from "./OidcCallbackPage.vue?vue&type=script&lang=js"
export * from "./OidcCallbackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__